import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import RoomItem from "./RoomItem";
import CardActions from "@material-ui/core/CardActions";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import Link from "@material-ui/core/Link";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Box from "@material-ui/core/Box";
import { loadCSS } from "fg-loadcss";
import Icon from "@material-ui/core/Icon";
import PruebaGoogleMaps from "./PruebaGoogleMaps";
import Dialog from "@material-ui/core/Dialog";
import Rating from "@material-ui/lab/Rating";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import HotelDetails from "../Components/Hotels/HotelDetails";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
// import { sizing } from "@material-ui/system";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles({
  root: {
    maxWidth: "lg",
    padding: 0,
    marginBottom: "1%",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "gray",
  },
  rootDestacado: {
    maxWidth: "lg",
    padding: 0,
    marginBottom: "1%",
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#FE5215",
  },
  buttonDestacado: {
    color: "#FE5215",
    fontSize: "9px",
    borderColor: "#FE5215",
    paddingTop: "0px",
    paddingBottom: "0px",
  },
  separador: {
    marginBottom: 15,
    marginTop: 20,
  },
  RoomsCard: {
    padding: 0,
    margin: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  RoomsCardAction: {
    padding: 0,
    margin: 0,
    backgroundColor: "#ffe0b2",
  },
  RoomsDescription: {
    paddingTop: "1%",
    paddingLeft: "1%",
    paddingRight: "1%",
  },
  RoomsName: {
    paddingTop: "0.7%",
    paddingRight: "1%",
    paddingBottom: 0,
  },
  RoomsDireccion: {
    flexGrow: 1,
    paddingTop: "0px",
    paddingBottom: "1%",
    direction: "row",
    justify: "center",
    alignItems: "center",
  },
  RoomsContainer: {
    paddingBottom: "0.7%",
    backgroundColor: "white",
  },
  RoomsContainerDestacados: {
    paddingBottom: "0.7%",
    backgroundColor: "white",
  },
  GridImagen: {
    paddingBottom: "0%",
  },
  TituloHotel: {
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
    // fontWeight: 'bolder'
  },
  TituloHabitacion: {
    color: "#016AA2",
    fontFamily: "MontserratSemiBold",
    // fontWeight: 'bolder'
  },
  TituloRegimen: {
    color: "#757575",
    fontStyle: "oblique",
  },
  HotelAddress: {
    color: "#016AA2",
    fontStyle: "oblique",
    verticalAlign: "top",
    paddingBottom: 7,
  },
  HotelDescription: {
    display: "flex",
    alignItems: "center",
    paddingTop: "1%",
    paddingRight: "0.5%",
    height: 70,
    color: "#757575",
  },
  appBar: {
    position: "relative",
    backgroundColor: "#016AA2",
  },
  title: {
    marginLeft: 10,
    flex: 1,
  },
  operador: {
    color: "#E0E0E0",
    fontSize: "9px",
  },
  tooltip: {
    fontSize: "9px",
    backgroundColor: "#016AA2",
  },
  reservarNaranja: {
    background: "#FE5215",
    color: "white",
    fontFamily: "MontserratSemiBold",
    textTransform: "capitalize",
    "&:hover": {
      background: "#016AA2",
      color: "white",
    },
  },
});

const styles = {
  dialogPaper: {
    width: "800px",
    Height: "800px",
  },
};

function capitalizarPalabras(val) {
  if (typeof val === "undefined" || val === "") {
    return "";
  } else {
    try {
      return val
        .toLowerCase()
        .trim()
        .split(" ")
        .filter((item) => item.trim() !== "")
        .map((v) => v[0].toUpperCase() + v.substr(1))
        .join(" ");
    } catch (error) {
      console.error("errortoUpper");
      console.error(error);
    }
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HotelCard(resultX, i) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const parseHtml = require("html-react-parser");
  const [openPoliticas, setOpenPoliticas] = React.useState(false);
  const [policy, setPolicy] = React.useState([]);
  const [DescripcionCombinacion, setDescripcionCombinacion] = React.useState("");

  // const Tope = 3;
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0)
    const node = loadCSS(
      "https://use.fontawesome.com/releases/v5.12.0/css/all.css",
      document.querySelector("#font-awesome-css")
    );

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);

  function getRoomItemColumn() {
    var iAux = -1;
    var roomsListr = resultX.hotel.map(function (item) {
      iAux = iAux + 1;
      if (iAux < 3) {
   /*      console.log("mensaje");
        console.log(resultX.AgenciaWeb); */
        var mensajeReserva = "Reservar";
          if (resultX.AgenciaWeb === "Ibero" || resultX.AgenciaWeb === "MC" || item.Operador === "ATOM" ) {
            mensajeReserva = "Solicitar";
        }
        return (
          <RoomItem
            key={iAux}
            tipoItem="Column"
            total={resultX.hotel.length}
            onClick={bookingClick}
            bg={iAux % 2 === 0 ? "#F6F8FA" : "#e3f2fd"}
            HotelNombre={resultX.hotel[0].nombreHotel}
            DescripcionCombinacion={capitalizarPalabras(
              item.DescripcionCombinacion
            )}
            Regimen={capitalizarPalabras(item.Regimen)}
            montototal={item.montototal}
            IDCombinacion={item.IDCombinacion}
            Operador={item.Operador}
            IDEncabezado={item.IDEncabezado}
            hotelOperador={item.hotelOperador}
            moneda={item.moneda}
            mensajeReserva={mensajeReserva}
          ></RoomItem>
        );
      }
    });
    return roomsListr;
  }

  function getRoomItem(filter, hotel) {
    var iAux = 0;
    var roomsListr = resultX.hotel.map(function (item) {
      iAux = iAux + 1;
      if (filter && iAux <= 3) {
      } else {
        var mensajeReserva = "Reservar";
          if (resultX.AgenciaWeb === "Ibero" || resultX.AgenciaWeb === "MC" || item.Operador === "ATOM" ) {
            mensajeReserva = "Solicitar";
        }
        return (
          <RoomItem
            key={iAux}
            tipoItem="Row"
            onClick={bookingClick}
            bg={iAux % 2 === 0 ? "#F6F8FA" : "#e3f2fd"}
            HotelNombre={resultX.hotel[0].nombreHotel}
            DescripcionCombinacion={capitalizarPalabras(
              item.DescripcionCombinacion
            )}
            Regimen={capitalizarPalabras(item.Regimen)}
            montototal={item.montototal}
            IDCombinacion={item.IDCombinacion}
            Operador={item.Operador}
            IDEncabezado={item.IDEncabezado}
            hotelOperador={item.hotelOperador}
            moneda={item.moneda}
            mensajeReserva={mensajeReserva}
          ></RoomItem>
        );
      }
    });
    return roomsListr;
  }

  const bookingClick = (
    hotelOperador,
    IDCombinacion,
    Operador,
    IDEncabezado
  ) => {
    console.log("bookingClick-HotelCard");
    console.log(
      hotelOperador + " " + IDCombinacion + " " + Operador + " " + IDEncabezado
    );
    resultX.onClick(
      hotelOperador,
      IDCombinacion,
      Operador,
      IDEncabezado,
      resultX.tipo
    );
  };

  /* const handleOpenPoliticas = (
    IDEncabezado,
    IDCombinacion,
    Operador,
    DescripcionCombinacion
  ) => {
    axios
      .get(
        "https://webtravel2-online.com/APIhoteles/api/PoliticasRetrieve?idEncabezado=" +
          IDEncabezado +
          "&idCombinacion=" +
          IDCombinacion +
          "&Operador=" +
          Operador,
      )
      .then((response) => {
        if (response.data.length !== 0) {
          setPolicy(response.data[0].Condiciones);
          console.log(response.data);
        } else {
         
          var politicas = [];
          if (Operador === "ATOM") {
           politicas.push({
            Cargo: "",
            Descripcion: "",
            Fecha: "Favor consultar con Atom Travel",
            Habitacion: "",
            Tipo: "",
            })
          } else {
            politicas.push({
            Cargo: "se cobrará 100% del total de noches",
            Descripcion: "fff",
            Fecha: "ERROR EN WS ----- En gastos desde la reserva",
            Habitacion: "",
            Tipo: "",
          })
        }
          console.log("epaepaepa");
          console.log(politicas);
          setPolicy(politicas);
        }
      })
      .catch((error) => {
        console.log(error);
        var politicas = [];
        if (Operador === "ATOM") {
          politicas.push({
          Cargo: "",
          Descripcion: "",
          Fecha: "Favor consultar con Atom Travel",
          Habitacion: "",
          Tipo: "",
          })
        } else {
          politicas.push({
          Cargo: "se cobrará 100% del total de noches",
          Descripcion: "fff",
          Fecha: "ERROR EN WS ----- En gastos desde la reserva",
          Habitacion: "",
          Tipo: "",})
        }
        setPolicy(politicas);
        console.log(error);
        //setOpen(false);
      }); //
    setDescripcionCombinacion(DescripcionCombinacion);
    setOpenPoliticas(true);
  }; */

  const handleClickOpenDialog = () => {
    if (
      typeof resultX.hotel[0].Latitud == "undefined" ||
      typeof resultX.hotel[0].Longitud == "undefined"
    ) {
    } else {
      setOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCloseDialogPoliticas = () => {
    setOpenPoliticas(false);
  };

  const handleClickOpenDialogDetails = () => {
    console.log("resultX");
    console.log(resultX);
    setOpenDetails(true);
  };

  const handleCloseDialogDetails = () => {
    setOpenDetails(false);
  };

  const QuitaSaltoLineas = (descripcion) => {
    var descripcion1 = descripcion.replaceAll("<p>"," ").replaceAll("</p>"," - ").replaceAll("<br/>"," ").replaceAll("<br />"," ").replaceAll("<br>"," ");
/*     var descripcion2 = descripcion1.replaceAll("</p>"," - ")
    var descripcion3 = descripcion2.replaceAll("<br/>"," ").replaceAll("<br />"," ")
    var descripcion4 = descripcion3.replaceAll("<br>"," ") */
    console.log (descripcion1)
   return descripcion1;
 };

  return (
    <React.Fragment>
      <Card
        variant="outlined"
        className={
          resultX.hotel[0].destacado ? classes.rootDestacado : classes.root
        }
      >
        <CardContent className={classes.RoomsCard}>
          <Grid
            container
            spacing={1}
            className={
              resultX.hotel[0].destacado
                ? classes.RoomsContainerDestacados
                : classes.RoomsContainer
            }
          >
            <Grid item xs={3} className={classes.GridImagen}>
              <Paper className={classes.paper}>
                <CardMedia
                  component="img"
                  alt={resultX.hotel[0].nombreHotel}
                  height="160"
                  image={
                    resultX.hotel[0].UrlImagen1 == null
                      ? "./NoImagen.jpg"
                      : resultX.hotel[0].UrlImagen1
                  }
                  title={resultX.hotel[0].nombreHotel}
                />
              </Paper>
            </Grid>
            <Grid item xs={9} className={classes.RoomsDescription}>
              <Grid container spacing={1} className={classes.RoomsName}>
                <Grid item xs={9}>
                  <Typography variant="h6" className={classes.TituloHotel}>
                    {resultX.hotel[0].Operador === "ATOM" ? (
                      <React.Fragment>
                        {" "}
                        {resultX.hotel[0].nombreHotel}
                      </React.Fragment>
                    ) : (
                      <Link
                        href="#"
                        onClick={handleClickOpenDialogDetails}
                        className={classes.TituloHotel}
                      >
                        {" "}
                        {resultX.hotel[0].nombreHotel}
                      </Link>
                    )}
                  </Typography>
                  {typeof resultX.hotel[0].Latitud == "undefined" ||
                  typeof resultX.hotel[0].Longitud == "undefined" ? (
                    <Typography
                      variant="body2"
                      className={classes.HotelAddress}
                    >
                      <LocationOnIcon
                        fontSize="small"
                        className={classes.HotelAddress}
                      ></LocationOnIcon>
                      {capitalizarPalabras(resultX.hotel[0].Direccion)}
                    </Typography>
                  ) : (
                    <Link href="#" onClick={handleClickOpenDialog}>
                      <Box display="flex" alignItems="center">
                        <Box>
                          <LocationOnIcon
                            fontSize="small"
                            className={classes.HotelAddress}
                          ></LocationOnIcon>
                        </Box>
                        <Box>
                          <Typography
                            variant="body2"
                            className={classes.HotelAddress}
                          >
                            {capitalizarPalabras(resultX.hotel[0].Direccion)}
                          </Typography>
                        </Box>
                      </Box>
                    </Link>
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Grid container direction="column" alignItems="center">
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.TituloHotel}
                      >
                        {resultX.hotel[0].categoriaMapeada != "1" &&
                        resultX.hotel[0].categoriaMapeada != "2" &&
                        resultX.hotel[0].categoriaMapeada != "3" &&
                        resultX.hotel[0].categoriaMapeada != "4" &&
                        resultX.hotel[0].categoriaMapeada != "5" ? (
                          <div></div>
                        ) : (
                          <Rating
                            name="size-small"
                            value={parseInt(resultX.hotel[0].categoriaMapeada)}
                            size="small"
                            readOnly={true}
                            emptyIcon={<StarBorderIcon fontSize="inherit" />}
                          />
                        )}
                        {/*   {getStarImage(
                          resultX.hotel[0].categoriaMapeada,
                          resultX.hotel[0].categoria
                        )} */}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {resultX.hotel[0].destacado ? (
                        <Button
                          size="small"
                          variant="outlined"
                          className={classes.buttonDestacado}
                        >
                          Hotel destacado{" "}
                          <ThumbUpAltIcon
                            style={{
                              color: " #FE5215",
                              paddingLeft: "3px",
                              fontSize: "12px",
                            }}
                          />
                        </Button>
                      ) : (
                        /*   <Fragment>
                          <Tooltip title="Hotel destacado" arrow>
                            <ThumbUpAltIcon style={{ color: " #FE5215" }} />
                          </Tooltip>
                        </Fragment> */
                        <div></div>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {resultX.hotel[0].destacado ? (
                        <Typography
                          style={{ color: "white", fontSize: "10px" }}
                        >
                          {resultX.hotel[0].categoria}-
                          {resultX.hotel[0].Operador}-
                          {resultX.hotel[0].categoriaMapeada}
                        </Typography>
                      ) : (
                        <Typography
                          style={{ color: "white", fontSize: "10px" }}
                        >
                          {resultX.hotel[0].categoria}-
                          {resultX.hotel[0].Operador}-
                          {resultX.hotel[0].categoriaMapeada}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Box className={classes.HotelDescription}>
              <Typography variant="body2">
                  {resultX.hotel[0].DescripcionHotel == null ? (
                    ""
                  ) : QuitaSaltoLineas(resultX.hotel[0].DescripcionHotel).length > 360 ? (
                    <React.Fragment>
                      {parseHtml(
                        QuitaSaltoLineas(resultX.hotel[0].DescripcionHotel).substring(0, 360)
                      )}{" "}
                      <Link href="#" onClick={handleClickOpenDialogDetails}>
                        ...más información
                      </Link>
                    </React.Fragment>
                  ) : (
                    parseHtml(resultX.hotel[0].DescripcionHotel)
                  )}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider variant="middle" />
          <Grid
            container
            spacing={0}
            m={0}
            p={0}
            direction="row"
            alignItems="center"
            justify="center"
          >
            {getRoomItemColumn()}
          </Grid>
          {/* {expanded ? "" : getRoomItem(true, resultX.hotel[0].nombreHotel)} */}
        </CardContent>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {getRoomItem(true, resultX.hotel[0].nombreHotel)}
        </Collapse>
        {resultX.hotel.length > 3 ? (
          <CardActions className={classes.RoomsCardAction}>
            <div style={{ width: "100%" }}>
              {expanded ? (
                <React.Fragment>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box>
                      <IconButton
                        className={clsx(classes.expand, {
                          [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show less"
                      >
                        <Typography variant="body2">
                          Mostrar menos habitaciones
                        </Typography>
                        {/* <ExpandLessIcon></ExpandLessIcon> */}
                      </IconButton>
                    </Box>
                    <Box>
                      <Icon
                        className="fa fa-minus-circle"
                        fontSize="small"
                        style={{ color: "#FE5215" }}
                      />
                    </Box>
                  </Box>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Box>
                      <IconButton
                        className={clsx(classes.expand, {
                          [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                      >
                        <Typography variant="body2">
                          Más habitaciones
                        </Typography>
                      </IconButton>
                    </Box>
                    <Box>
                      <Icon
                        className="fa fa-plus-circle"
                        fontSize="small"
                        style={{ color: "#FE5215" }}
                      />
                    </Box>
                  </Box>
                </React.Fragment>
              )}
            </div>
          </CardActions>
        ) : (
          ""
        )}
      </Card>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
      >
        <PruebaGoogleMaps
          hotel={resultX.hotel[0]}
          bar={true}
        ></PruebaGoogleMaps>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDetails}
        onClose={handleCloseDialogDetails}
        TransitionComponent={Transition}
      >
        <HotelDetails
          hotel={resultX}
          bar={false}
          zoneName={resultX.zoneName}
          countryFlag={resultX.countryFlag}
          onClick={handleCloseDialogDetails}
        ></HotelDetails>
      </Dialog>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openPoliticas}
        onClose={handleCloseDialogPoliticas}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPoliticas}>
          <div className={classes.paper}>
            {policy.length > 0 ? (
              <React.Fragment>
                <Typography variant="h6" className={classes.TituloHotel}>
                  Políticas de Cancelación
                </Typography>
                <Box
                  display="flex"
                  justifyContent="center"
                  verticalAlign="center"
                  m={1}
                  p={1}
                  css={{ width: "100%" }}
                >
                  <Typography variant="h6" className={classes.TituloHotel}>
                    {resultX.hotel[0].HotelNombre}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.TituloHabitacion}
                  >
                    {DescripcionCombinacion}
                  </Typography>
                </Box>
                <Divider variant="middle" className={classes.separador} />

                <List className={classes.root}>
                  {policy.map((resultX, i) => (
                    <ListItem>
                      <ListItemText
                        key={i}
                        primary={resultX.Fecha}
                        secondary={resultX.Cargo}
                      />
                    </ListItem>
                  ))}
                </List>
              </React.Fragment>
            ) : (
              <CircularProgress />
            )}
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
